import React, { useState } from 'react'
import PropTypes from 'prop-types'
import TuneIcon from '@mui/icons-material/Tune'

import { postRejectBill } from '../../dataClient/apiCalls'
import { StyledDialog, FlexEndContainer, FlexDialogContent, FlexColumn } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import BodyText, { BoldSpan, BoldFormTitle } from '../styles/Text'
import Button, { SecondaryButton } from '../common/Button'

function RejectEstimateButton({ billId, secondaryId, onSuccess = () => {} }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => {
    setIsVisible(false)
    setError(false)
    setIsLoading(false)
  }

  async function handleConfirm() {
    setIsLoading(true)
    setError(false)

    postRejectBill(billId)
      .then(() => {
        handleClose()
        onSuccess()
      })
      .catch(e => {
        console.error('Failed rejecting estimate', e)
        setError(true)
        setIsLoading(false)
      })
  }

  return (
    <>
      <SecondaryButton aria-label="Reject Estimate & Amend Scope" onClick={handleOpen}>
        <TuneIcon />
        Reject Estimate & Amend Scope
      </SecondaryButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <FlexDialogContent>
          <FlexColumn>
            <BoldFormTitle>Reject Estimate & Amend Request Scope</BoldFormTitle>
            <BodyText>
              Are you sure you want to reject the estimate for <BoldSpan>{secondaryId}</BoldSpan>? After rejecting, you will need to contact the city
              to amend the scope of your request.
            </BodyText>
            {error && <ErrorMessage>There was an error rejecting the estimate. Please try again.</ErrorMessage>}
            <FlexEndContainer>
              <SecondaryButton onClick={handleClose} disabled={isLoading}>
                Go back
              </SecondaryButton>
              <Button onClick={handleConfirm} loading={isLoading}>
                Confirm
              </Button>
            </FlexEndContainer>
          </FlexColumn>
        </FlexDialogContent>
      </StyledDialog>
    </>
  )
}

RejectEstimateButton.propTypes = {
  billId: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}

export default RejectEstimateButton
